import { graphql, useStaticQuery } from "gatsby"

// Every episode, newest first, for the podcast episode library. (Gatsby
// allows one static query per file, so this is separate from
// usePodcastEpisodes.)
export const useAllPodcastEpisodes = () => {
  const { allPodcastEpisode } = useStaticQuery(graphql`
    query GetAllPodcastEpisodes {
      allPodcastEpisode(sort: { fields: publishedOn, order: DESC }) {
        nodes {
          id
          applePodcastLink
          slug
          durationMinutes
          episode
          releaseDate: publishedOn(formatString: "MMM D, YYYY")
          searchText
          spotifyLink
          summary
          title
          topics
          youtubeLink
        }
      }
    }
  `)
  return allPodcastEpisode.nodes
}
